import { render, staticRenderFns } from "./ShareGoalPanel.vue?vue&type=template&id=3fe89864&scoped=true"
import script from "./ShareGoalPanel.vue?vue&type=script&lang=js"
export * from "./ShareGoalPanel.vue?vue&type=script&lang=js"
import style0 from "./ShareGoalPanel.vue?vue&type=style&index=0&id=3fe89864&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe89864",
  null
  
)

export default component.exports